module.exports = __webpack_public_path__ + "dceee523e4e7abb246f36476d5dda252.png";